export const pagesITOperationCoreEn = {
  title: "IT Operation Core",

  abort: "Abort",
  accounts: "Accounts",
  accountRole: "Account role",
  addPattern: "Add operation package pattern",
  app: "App",
  apps: "Apps",
  adminPage: "Admin/service page",
  archive: "Archive",
  automatedProvisioning: "Automated provisioning",
  colon: ":",
  complete: "Complete",
  completed: "Completed",
  config: "Config",
  confirm: "Confirm",
  copyCredential: "Copy all the login info",
  copiedToClipboard: "Copied to clipboard",
  edit: "Edit",
  execute: "Execute",
  failedToAbort: "Failed to abort.",
  failedToCompleteTask: "Failed to complete.",
  failedToDeprovisionAppUser:
    "Failed to deprovision app user.\nPlease deactivate/delete the account manually.",
  failedToProvisionAppUser:
    "Failed to provision app user.\nPlease create the account manually.",
  skippedProvisionAppUser: "Skipped to provision app user.",
  failedToStartTaskTitle: "Failed to start.",
  goToAdminPageCreate:
    "Go to the admin/service page and create the accounts for the listed below.",
  goToAdminPageDeactivate:
    "Go to the admin/service page and deactivate the accounts for the listed below.",
  groupBy: "by {{group}}",
  data: "Data",
  detail: "Detail",
  emptyPackagePatternTitle: "No operation package patterns",
  emptyPackagePatternDescription:
    'Please register by clicking the "Add operation package pattern" button.',
  emptyInstanceTitle: "No operation task",
  emptyInstanceDescription:
    "No operation task found. Please register from the Add operation task button above.",
  filterPersonApp: "Search by name or email address",
  id: "ID",
  provisioningDate: "Provisioning Date",
  individualProvisioning: "Individual provisioning",
  invalid: "Invalid",
  letThemKnowPassword: "Let them know their ID and password for login.",
  markAsComplete: "Mark as complete",
  labelAttachmentWaitingForPrint:
    "After the label printing task is completed, the task will be automatically generated after a while.",
  processing: "Processing...",
  notApplicable: "Not applicable",
  openMenu: "Open menu",
  operationActivity: "Operation activity",
  operationPackages: "Operation packages",
  password: "Password",
  person: "Person",
  people: "People",
  pleaseTryAgainLater: "Please try again later.",
  productName: "IT Operation Core",
  progress: "Progress",
  provisionDate: "Provision date",
  requestedFor: "Requested for",
  scheduled: "Scheduled",
  selectAll: "Select all",
  selectDate: "Select date",
  selected: "Selected",
  setDate: "Set date",
  setProvisionDate:
    "Set the provisioning date for tomorrow or later. It will be executed at 8:00 AM on the set date.",
  showSummary: "Show summary",
  skip: "Skip",
  start: "Confirm targets",
  startNew: "Start new",
  startToFetchAppUser: "Start to fetch app user account.",
  successToCompleteTask: "Succeeded to complete.",
  successToAbort: "Succeeded to abort.",
  successToSkip: "Succeeded to skip.",
  successToStartTaskTitle: "Succeeded to start.",
  successToStartTaskDescription: "Please wait for the task to complete.",
  taskProgress: "Task progress",
  tenantName: "Tenant name",
  unableToRetrieve: "Unable to retrieve",
  unknownRole: "(Unknown account role)",
  view: "View",
  viewData: "View: data",
  waitingForCreatingAppUser: "Waiting for creating app user account",
  displayCompact: "Compact",
  filterDevices: "Filter devices...",
  labelType: "Label type",
  allLabelTypes: "All label types",
  allDevices: "All devices",
  labelGenerated: "Label generated",
  labelNotGenerated: "Label not generated",
  printOptions: {
    printSettings: "Print settings",
    labelSize: "Label size",
    paperSize: "Paper size",
    margin: "Margin",
    layout: "Layout",
    assetTag: "Asset tag",
    qrCode: "QR code",
    deviceName: "Device name",
    deviceTag: "Device tag",
    none: "None",
    vertical: "Vertical",
    horizontal: "Horizontal",
    additionalContent: "Additional content",
  },

  labelSpecs: {
    label24FacesA4: "24 Labels (A4)",
  },

  // 以下は使い回さない想定なので、できる限り構造化していく
  demo: {
    underDevelopment: "This operation package is currently under development.",

    // Apps
    accountCreationRequest: "Account creation request",
    accountDeletionRequest: "Account suspension/deletion request",
    bulkAccountCreation: "Bulk account creation",
    bulkAccountDeletion: "Bulk account suspension/deletion",
    emailAddressRequest: "Email address request",
    licenseRequest: "License request",
    newSoftwareRequest: "New software request",
    passwordInitializationRequest: "Password initialization/reset request",
    sharedIdGroupCreationRequest: "Shared id group creation request",
    sharedIdGroupJoiningRequest: "Shared id group joining request",
    softwareInstallationRequest: "Software installation request",
    systemIntegrationPermissionRequest: "System integration permission request",

    // Devices
    deviceArrangementRequest: "Device arrangement request",
    deviceBorrowRequest: "Device borrow request",
    deviceComputerVirusDetection: "Computer virus detection/ infection report",
    deviceExchangeRequest: "Device exchange request",
    deviceInitializationRequest: "Device initialization request",
    deviceRepairRequest: "Device repair request",
    deviceSetupRequest: "Device setup request",

    // Shared Drive
    sharedDriveAccessPermissionRequest:
      "Shared drive access permission request",
    sharedDriveCreationRequest: "Shared drive creation request",
    sharedDriveExternalSharingApplication:
      "Shared drive external sharing application",

    // Network
    incidentStatusInvestigationReport: "Incident status investigation report",
    networkConnectionRequest: "Network connection request",
    vpnConnectionRequest: "VPN connection request",
  },

  device: "Device",
  labelGeneration: "Label generation",
  labelPrinting: "Label printing",
  labelAttachment: "Label attachment",

  newRequestDialog: {
    title: "Start a new operation package: {{packageName}}",
    selectPattern: "Select pattern",
    selectPatternDescription:
      "Please select the pattern for this operation package.",
    selectPersonAndDateDescription:
      "Please select the target people and reference date.",
    peopleLabel: "Targets",
    deviceLabel: "Devices",
    personSearchPlaceholder: "Search by name or email address",
    dateLabel: "Date",
    startButtonLabel: "Start",
    cancelButtonLabel: "Cancel",
    target: "Target",
    joiningMembers: "Joining members",
    leavingMembers: "Leaving members",
    requiredUsers: "Required users",
    violatedUsers: "Users to deactivate",
    alumniUsers: "Alumni users",
    member: "Member",
    joiningDate: "Joining date",
    leavingDate: "Leaving date",
    noJoiningMembers: "No joining members",
    noLeavingMembers: "No leaving members",
    noRequiredUsers: "No required users",
    loading: "Loading...",
    displayLimitExceeded:
      "Display limit applied due to large number of targets",
    addIndividually: "Add individually",
    defaultAnchorDateLabel: "Reference date: Provisioning completion deadline",
    deviceSelectionMode: {
      allUnissued: "All unissued devices",
      allUnlabeled: "All unlabeled devices",
      group: "Select by group",
      selected: "Select individually",
    },
  },

  deviceInventory: {
    toolbar: {
      search: {
        placeholder: "Search by device name or tag...",
      },
      filters: {
        status: {
          label: "Status",
          placeholder: "Status",
          all: "All",
          good: "Good",
          bad: "Bad",
          unreported: "Unreported",
        },
        type: {
          label: "Type",
          placeholder: "Type",
          all: "All",
          assigned: "Assigned",
          installed: "Installed",
        },
      },
      actions: {
        clearFilters: "Clear filters",
        refresh: "Refresh data",
        export: "Export CSV",
      },
      summary: {
        devicesReported:
          "{{reportedDevices}} of {{totalDevices}} devices reported",
      },
      activeFilters: {
        label: "Active filters:",
        search: 'Search: "{{query}}"',
        status: "Status: {{status}}",
        type: "Type: {{type}}",
      },
    },
  },

  tabs: {
    config: "Config",
  },

  configPage: {
    chooseEligibleTargets: "Choose eligible targets",
    eligiblePeopleGroup: "Eligible people group",
    createPeopleGroupIfNeeded: "Create people group if needed",
    openPeopleGroupSettings: "Open people group settings",
    eligibleTarget: "Eligible target",
    description: "Description",
    anchorDate: "Anchor date",
    requestedDate: "Requested date",
    value: "Value",
    abortChanges: "Abort changes",
    saveDraft: "Save draft",
    createPeopleGroupIfNotExists:
      "If there is no necessary people group, create one.",
    toPeopleGroup: "Open people group",
  },

  toast: {
    labelGenerationSuccess: "Label generation completed",
    labelGenerationSuccessDetail:
      "Successfully generated {{count}} management labels",
    labelGenerationFailed: "Failed to generate labels",
    labelGenerationError: "An unexpected error occurred",
  },
};
